import axios from 'axios'
import store from '@/store.js'

export default () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
      Authorization: `Bearer ${store.getters.token}`
    }
  })
}